import React from 'react';
import { withPlaceholderProvider } from '../../../features/placeholderComponent/withPlaceholderComponent';
import { ContentDocuments } from './components/contentDocuments/ContentDocuments';

const Documents = () => {
  return <ContentDocuments />;
};

export default withPlaceholderProvider(Documents);
